<template>
  <ModulePlugin :modulePluginStore="modulePluginStore" />
</template>

<script>
import ModulePlugin from "../../../../dt-plugins/module-plugins/module-plugins";

import { AccountingModulePluginStore } from "../../store/plugin-store";

export default {
  components: {
    ModulePlugin,
  },
  data() {
    return {
      modulePluginStore: AccountingModulePluginStore,
    };
  },
  //MARK: Methods
};
</script>
